import { extend } from 'vee-validate';
import { ValidationUtil } from '../util/validation/validation.util';

extend('cpf', value => {
  if(ValidationUtil.validCPF(value)) {
    return true;
  }
  return 'Este cpf é inválido';
});
